import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { Document } from "../../core/model/document";
import { Workflow } from "../../core/model/workflow";
import { WorkflowService } from "../../core/service/workflow.service";
import { DocumentService } from "../../core/service/document.service";

@Component({
  selector: "app-add-check-list",
  templateUrl: "./add-check-list.component.html",
  styleUrls: ["./add-check-list.component.scss"],
})
export class AddCheckListComponent implements OnInit {
  form2: FormGroup;
  pressButton: Boolean = false;

  workflows: Workflow[];
  document: Document = new Document();

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _workflowService: WorkflowService,
    private _documentService: DocumentService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      obligatoire: [null, Validators.compose([Validators.required])],
      label: [
        null,
        [Validators.compose([Validators.required]), Validators.maxLength(255)],
      ],
      workflow: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getWorkflows();
  }

  getWorkflows() {
    this._workflowService.getAllWorkflows().subscribe(
      (data) => {
        this.workflows = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.document.active = true;
    this.document.code = this.document.code.replace(" ", "_");

    this.pressButton = true;
    this._documentService
      .add(this.document)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
